<div class="container-padded">
  <div class="inner-content card">
    <span class="filters-section">
      <form>
        <mat-form-field appearance="outline" class="string-filter-field">
          <input matInput test-id="filter-input" [formControl]="$any(form.get('searchString'))" placeholder="Filter by project attributes">
        </mat-form-field>

        @if (projectTags.length > 0) {
          <span>
            <span class="filter-section-header">Project Tags</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(projectTags)"
              [formControl]="$any(form.get('projectTags'))">
            </fw-chip-selector>
          </span>
        }

        @if (therapeuticAreaFilters.length > 0) {
          <span>
            <span class="filter-section-header">Therapeutic Areas</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(therapeuticAreaFilters)"
              [formControl]="$any(form.get('therapeuticAreas'))">
            </fw-chip-selector>
          </span>
        }

        @if (bodyRegionFilters.length > 0) {
          <span>
            <span class="filter-section-header">Body Regions</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(bodyRegionFilters)"
              [formControl]="$any(form.get('bodyRegions'))">
            </fw-chip-selector>
          </span>
        }

        @if (organSystemFilters.length > 0) {
          <span>
            <span class="filter-section-header">Organ/System</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(organSystemFilters)"
              [formControl]="$any(form.get('organSystems'))">
            </fw-chip-selector>
          </span>
        }

        @if (ageFilters.length > 0) {
          <span>
            <span class="filter-section-header">Age</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(ageFilters)"
              [formControl]="$any(form.get('ageFilters'))">
            </fw-chip-selector>
          </span>
        }

        @if (fileTypeFilters.length > 0) {
          <span>
            <span class="filter-section-header">File Types</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(fileTypeFilters)"
              [formControl]="$any(form.get('fileTypeFilters'))">
            </fw-chip-selector>
          </span>
        }

        @if (modalityFilters.length > 0) {
          <span>
            <span class="filter-section-header">Modality</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(modalityFilters)"
              [formControl]="$any(form.get('modalities'))">
            </fw-chip-selector>
          </span>
        }

        @if (measurementFilters.length > 0) {
          <span>
            <span class="filter-section-header">Measurement/Scan</span>
            <fw-chip-selector
              [chipsToShow]="7"
              [options]="$any(measurementFilters)"
              [formControl]="$any(form.get('measurementAndScanTags'))">
            </fw-chip-selector>
          </span>
        }
      </form>
    </span>
    <span class="project-list-section">
      @if (projectList.length > 0) {
        @for (project of projectList; track project; let projectIndex = $index) {
          <mat-card appearance="outlined">
            <mat-card-content>
              <span class="project-summary">
                <span class="avatar-and-contact">
                  <span
                    class="avatar"
                    [style.backgroundColor]="project.avatarColor"
                    [style.backgroundSize]="'cover'">
                    {{ project.avatarInitials }}
                  </span>
                  <span class="project-label">
                    <!-- TODO: Once share_level and full_ro_access are available, create link to project -->
                    <!-- <a test-id="project-catalog-label" href="#/projects/{{ project.id }}/description">{{ project.label }}</a> -->
                    {{ project.label }}
                    <span class="contact-information">
                      <a href="{{ project.project_institutions[0].url }}" target="_blank" rel="nofollow noopener" test-id="project-institution-link">{{ project.project_institutions[0].name }}</a>
                      <a href="mailto:{{ project.project_contacts[0].email }}" target="_blank" test-id="project-contact-email-link">{{ project.project_contacts[0].email }}</a>
                    </span>
                  </span>
                </span>
                <span class="project-description">
                  @if (project.truncatedSummary !== project.summary) {
                    <span>
                      {{ project.readMore ? project.truncatedSummary : project.summary }} @if (project.readMore) {
                      <span>...</span>
                    }
                    <a type="button" (click)="project.readMore = !project.readMore" test-id="read-more-less-link">
                      {{ project.readMore ? 'Read More': 'Read Less' }}
                    </a>
                  </span>
                } @else {
                  <span>{{ project.summary }}</span>
                }
              </span>
            </span>
            <span class="project-metadata">
              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.subjects ?  project?.stats.number_of.subjects : '-' }}
                </span>
                <span class="metadata-label">
                  Subjects
                </span>
              </span>
              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.sessions ?  project?.stats.number_of.sessions : '-' }}
                </span>
                <span class="metadata-label">
                  Sessions
                </span>
              </span>
              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.acquisitions ?  project?.stats.number_of.acquisitions : '-' }}
                </span>
                <span class="metadata-label">
                  Acquisitions
                </span>
              </span>
              <span class="metadata-block">
                <span class="data">
                  {{ project.stats?.number_of.files ?  project?.stats.number_of.files : '-' }}
                </span>
                <span class="metadata-label">
                  Files
                </span>
              </span>
            </span>
          </mat-card-content>
          <mat-card-footer>
            <mat-chip-set>
              @for (tag of project.chips; track tag) {
                <mat-chip class="gray-chip">{{ tag }}</mat-chip>
              }
            </mat-chip-set>
          </mat-card-footer>
        </mat-card>
      }
      <div (fwLoadTrigger)="loadMore$.next()" class="load-trigger"></div>
    } @else {
      <div class="blank-state">
        <p>No projects were found.</p>
      </div>
    }

  </span>
</div>
</div>
